export default function (state, getters, rootState, rootGetters) {
    return state.page * getters.setting.col - 1;
}